import { render, staticRenderFns } from "./InitQuestionnaire.vue?vue&type=template&id=4b2cb989&scoped=true&"
import script from "./InitQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./InitQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./InitQuestionnaire.vue?vue&type=style&index=0&id=4b2cb989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2cb989",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VDatePicker,VMenu,VSwitch,VTextField,VTextarea,VTimePicker})
